import { SortDirections } from '@shared/constants/SortDirections';
import { PatientSortingFields } from '@shared/constants/sortingFields';
import { ChangePatientsSortingPayload } from '@shared/redux/actions/payloadTypes/patientActionPayloads';
import { ActionWithPayload } from '@shared/redux/actions/typings';

export const PATIENTS_ADMIN_LIST_SET_SORTING = 'PATIENTS_ADMIN_LIST_SET_SORTING';

export const setSorting = (
  field: PatientSortingFields,
  defaultSortDirection?: SortDirections,
): ActionWithPayload<ChangePatientsSortingPayload> => ({
  type: PATIENTS_ADMIN_LIST_SET_SORTING,
  payload: {
    field,
    defaultSortDirection,
  } as { field: PatientSortingFields; defaultSortDirection?: SortDirections },
});

export type SetSorting = ReturnType<typeof setSorting>;
